export default {
    to: "/dashboard/api-reference/introduction",
    order: 3,
    icon: "mdi-clock-start",
    title: "Getting Started",
    disabled: false,
    value: 0,
    // sublinks: [
    //     {
    //         to: "/dashboard/api-reference/introduction",
    //         order: 3,
    //         icon: "mdi-access-point-check",
    //         title: "Introduction",
    //         disabled: false,
    //         value: 0,
    //     },
    //     {
    //         to: "/dashboard/api-reference/nomenclature",
    //         order: 3,
    //         icon: "mdi-instrument-triangle",
    //         title: "Nomenclature",
    //         disabled: false,
    //         value: 0,
    //     },
    // ],
}
